/**
 * Целочисленная арифметика в наноединицах. Все деления здесь явные: округление
 * вниз или вверх выбирается вызывающим кодом, потому что от направления
 * округления зависит, кто платит за остаток — пользователь или резерв кривой.
 */

/** Деление с округлением вниз. Работает и для отрицательных значений. */
export function floorDiv(a: bigint, b: bigint): bigint {
  if (b === 0n) {
    throw new Error('floorDiv: division by zero');
  }
  const q = a / b;
  const r = a % b;
  if (r !== 0n && a < 0n !== b < 0n) {
    return q - 1n;
  }
  return q;
}

/** Деление с округлением вверх. */
export function ceilDiv(a: bigint, b: bigint): bigint {
  if (b === 0n) {
    throw new Error('ceilDiv: division by zero');
  }
  const q = a / b;
  const r = a % b;
  if (r !== 0n && a < 0n === b < 0n) {
    return q + 1n;
  }
  return q;
}

/** `a * b / c` с округлением вниз. */
export function mulDivFloor(a: bigint, b: bigint, c: bigint): bigint {
  return floorDiv(a * b, c);
}

/** `a * b / c` с округлением вверх. */
export function mulDivCeil(a: bigint, b: bigint, c: bigint): bigint {
  return ceilDiv(a * b, c);
}

export function min(a: bigint, b: bigint): bigint {
  return a < b ? a : b;
}

export function max(a: bigint, b: bigint): bigint {
  return a > b ? a : b;
}

/**
 * Целый квадратный корень, округлённый вниз. Нужен harvest: доля локера в пуле
 * считается через `sqrt(k)`, а в TON нет вещественных чисел.
 */
export function isqrt(n: bigint): bigint {
  if (n < 0n) {
    throw new Error('isqrt: negative');
  }
  if (n < 2n) {
    return n;
  }
  let x = n;
  let y = (n + 1n) / 2n;
  while (y < x) {
    x = y;
    y = (x + n / x) / 2n;
  }
  return x;
}

/** Целый квадратный корень, округлённый вверх. */
export function isqrtCeil(n: bigint): bigint {
  const s = isqrt(n);
  return s * s < n ? s + 1n : s;
}
